import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const timerecordDataClassName = DataClassName.TIMERECORD
const timerecordEndpoint = PisaDataClassEndpoint.TIMERECORD

export function pisaTimerecordDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(timerecordDataClassName, {
    title: timerecordDataClassName,
    restApi: createPisaRestApiConfig(timerecordEndpoint),
    attributes,
  })
}
